<template>
  <form name="smsConfrm">
    <div class="smsConfrmProcess">
    <div class="formStepTitle">
      Подтвердите номер телефона
    </div>
    <div id="asdasdasd">
      <fmInput :refs="'SmsConfCode'"></fmInput>
      <p>На ваш номер телефона отправлен код подтверждения</p>
      <!-- <a v-on:click="reSendCode" v-if="errorCode > 0">Повторно отправить код</a> -->
      <p><a v-on:click="reSendCode" v-bind:class="{'canClick':timerCount <= 0}">Повторно отправить код</a> через {{ timerCount }} сек </p>
    </div>
    <div id="asp">
      <scheckBox
        :name="'ASP'"
        :true-value="true"
        :false-value="false"
      ></scheckBox>
      <a href="https://finmoll.ru/documents/soglashenie-ob-ispolzovanii-asp.pdf" target="_blank">Согласие об
        использовании аналога собственноручной подписи</a>
    </div>

    <nxtButton v-on:submitStep="submitStep"></nxtButton>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';

  export default {
    name: "confirmSms",
    data() {
      return {
        allRigth: true,
        timerCount: 120,
        ConfirmationGUID: null,
        refsStepArr:[
          'SmsConfCode',
          'ASP'
        ]
      }
    },
    components: {
      fmInput: () => import('@/components/form/fmInput'),
      nxtButton: () => import('@/components/form/nextButton'),
      scheckBox: () => import('@/components/form/fmCheckBoxB'),
    },
    mounted() {

      //todo [p_ExternalExecute_CheckDecisionByID] вызывем в фоне и ждем результат, возможно придется вызывать много раз

      this.SMSConfirmationLid()
        .then((res)=>{
          console.log(res)
        })
        .catch((res)=>{
          console.log(res)
        }).finally(()=>{
        window.dblClick = false;
        window.scrollTo(0, this.$parent.$refs.formAlign.offsetTop);
      });
      if (window.ym) {
        // eslint-disable-next-line no-undef
        ym(51632228, 'reachGoal', 'admdPdlContact');
      }
    },
    methods: {
      insertPixel(src,tagg) {
        let pixel = document.createElement(tagg);
        pixel.src = src;

        if (tagg === 'img') {
          pixel.setAttribute('style','position:absolute;width:1px;height:1px;opacity:0;top:0;left:-100px;');
          let targetInsert = document.getElementById("app");
          document.body.insertBefore(pixel, targetInsert);
        } else if(tagg === 'script') {
          document.getElementsByTagName('head')[0].appendChild(pixel);
        }
      },
      sendData() {
        this.$palantir.trackAction(141,'');
        this.$store.dispatch('showLoading');
          let preSendData  =Object.assign({}, this.valueVuex);
          if (preSendData.CALC_SUMM < this.minBaseProduct.Amount) {
            //magic number, не трогай блиятть
            preSendData.CALC_SUMM = 25000;
          }
          if (preSendData.CALC_SUMM > this.maxBaseProduct.Amount) {
            preSendData.CALC_SUMM = this.maxBaseProduct.Amount;
          }

          this.$myApi.singleRequest({
            action:'SendRequest',
            data:preSendData
          }).then((res) => {
            this.$palantir.trackAction(142,JSON.stringify(res));
            if (res.pixel != undefined) {
              this.insertPixel(res.pixel,res.tagg);
            }
            this.$store.commit('saveSystemData',{
              target:'loanid',
              value:res.loadnId
            });

            if (window.ym) {
                  // eslint-disable-next-line no-undef
                  ym(51632228, 'reachGoal', 'allRequest');
                }
                if (window.ga){
                  // eslint-disable-next-line no-undef
                  ga('send', 'event', 'admdForm', 'admdForm');
                }
                try {
                  // eslint-disable-next-line no-undef
                  VK.Goal('lead')
                } catch (e) {
                  console.log(e);
                }

          this.$store.dispatch('hideLoading');
          this.$store.dispatch('formRouting', 'pdlThanks');

          }).catch((res) => {
            this.$palantir.trackAction(143,JSON.stringify(res));
            console.log(res);
          });

      },
      checkFormFieldValue(){
        //проверяем заполнения полей

        let isFormFieldCorrect = true;
        this.refsStepArr.forEach(item => {
          if (this.statusVuex[item].code != 0) {
            this.$palantir.trackAction(117,item);
            this.$store.dispatch('errorShow', {
              target: item,
              value: true,
            });
            isFormFieldCorrect = false;
          }
        });

        return isFormFieldCorrect;
      },
      SMSConfirmationLid(){
        return new Promise(((resolve, reject) => {
           this.$palantir.trackAction(134,this.phoneVuex);
          this.$store.dispatch('showLoading');
          this.$myApi.SendRequest({
            action: 'SMSConfirmationLid',
            PHONE: this.phoneVuex,
          }).then((res) => {
            this.$palantir.trackAction(134,res.ConfirmationGUID);
            this.ConfirmationGUID = res.ConfirmationGUID;
            localStorage.setItem('ConfirmationGUID',res.ConfirmationGUID);
            resolve(res);
          }).catch((res) => {
            this.$palantir.trackAction(135,JSON.stringify(res));
            let ErrorResult = this.$myApi.parseError(res, 'SMSConfirmationLid');
            reject(ErrorResult);
            this.ConfirmationGUID = localStorage.getItem('ConfirmationGUID');
          })
          .finally(() => {
            this.$store.dispatch('hideLoading');
            window.scrollTo(0, this.$parent.$refs.formAlign.offsetTop);
          });
        }));
      },
      reSendCode(){
        if (this.timerCount > 0) return false;
        this.timerCount = 120;
        this.$store.dispatch('saveSendData', {
          target: 'SmsConfCode',
          value: ''
        });
        this.SMSConfirmationLid()
          .then((res)=>{
           console.log(res)
          })
          .catch((res)=>{
            console.log(res)
          }).finally(()=>{
            window.dblClick = false;
            window.scrollTo(0, this.$parent.$refs.formAlign.offsetTop);
        });
      },
      manualError(str) {
        this.$store.dispatch('hideLoading');
        this.$store.dispatch('fieldError',{
          target: 'SmsConfCode',
          value: str,
        });
      },
      logSmsConfCode(result){
        this.$myApi.singleRequest({
          action:'logSmsConfCode',
          result:result
        }).then(res=>console.log(res))
        .catch(res=>console.log(res));
      },
      submitStep() {
        if (this.checkFormFieldValue()) {
          this.$store.dispatch('showLoading');
          this.$palantir.trackAction(137,this.ConfirmationCode);
          this.$myApi.SendRequest({
            action: 'SMSConfirmationCodeCheck',
            ConfirmationGUID: this.ConfirmationGUID,
            ConfirmationCode: this.ConfirmationCode,
          }).then(res => {
            if (res.CheckResult == true) {
              this.$palantir.trackAction(138,'');
              this.logSmsConfCode(1);
              this.sendData();
              console.log('sendingData')

            } else {
              this.$palantir.trackAction(139,'');
              this.logSmsConfCode(-1);
              this.manualError('Некорректный  код');
            }
            window.dblClick = false;
          }).catch((res) => {
            this.$palantir.trackAction(140,JSON.stringify(res));
            let ErrorResult = this.$myApi.parseError(res, 'SMSConfirmationLid');
            this.logSmsConfCode(-2);
            if (ErrorResult.ExecutionErrorCode > 0) {
              this.manualError('Некорректный  код');
            }
            window.dblClick = false;
          });
        } else {
          window.dblClick = false;
        }
      },
    },
    computed: {
      ...mapState({
        ConfirmationCode: state => state.Form.sendData.SmsConfCode,
        phoneVuex: state => state.Form.sendData.PHONE,
        errorCode: state=> state.Form.workData.PHONE.code,
        statusVuex: state => state.Form.workData,
        systemFormVuex: state => state.Form.system,
        valueVuex: state => state.Form.sendData,
        minBaseProduct:state=>state.Deal.minBaseProduct,
        maxBaseProduct:state=>state.Deal.maxBaseProduct,
      }),
      ...mapGetters(['isConfirmPhone']),
    },
    watch: {
     timerCount: {
      handler(value) {
       if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
       immediate: true
      }
     }
  }
</script>

<style scoped>
  #asdasdasd {display: flex;align-items: center;flex-direction: column;padding-bottom: 20vw;}
  #asdasdasd > p {text-align: center}
  a{text-decoration: underline;padding-top: 4vw;}
  #asp{text-align: center}
  /deep/ #asp .visualCheckBox{border: 1px solid #c2c2c2;}
  /deep/ #asp .visualCheckBox.active{stroke: #43AC35}
  @media screen and (min-width: 760px) {
    #asdasdasd {padding-bottom: 5vw;}
    a{padding-top: 1.5vw}

  }
  @media screen and (min-width: 1140px) {
    #asdasdasd {padding-bottom: 40px;}
    a{padding-top: 10px;}
  }
</style>
